/**
 * Do not edit directly
 * Generated on Wed, 26 Mar 2025 13:45:33 GMT
 */

export const THEME_COLOR_PRIMARY = "#0093F5";
export const THEME_COLOR_SECONDARY = "orange";
export const THEME_COLOR_PRIVATE_FOCUS = "#7fd6ff";
export const THEME_COLOR_FOCUS = "#002F87";
export const THEME_COLOR_PRIVATE_DISABLED = "#b0b0b0";
export const THEME_COLOR_DISABLED = "#b0b0b0";
export const THEME_COLOR_PRIVATE_PLACEHOLDER = "#b0b0b0";
export const THEME_COLOR_PLACEHOLDER = "#b0b0b0";
export const THEME_COLOR_TRANSPARENT = "transparent";
export const THEME_COLOR_CURRENT = "currentColor";
export const THEME_COLOR_LIGHTEST = "#FFFFFF";
export const THEME_COLOR_DARKEST = "#000000";
export const THEME_COLOR_BASE_BACKGROUND = "#FFFFFF";
export const THEME_COLOR_TEXT_LIGHT = "#FFFFFF";
export const THEME_COLOR_TEXT_PRIVATE_DARK = "#404040";
export const THEME_COLOR_TEXT_DARK = "#404040";
export const THEME_COLOR_NEUTRAL_LIGHT_50 = "#e5e5e5";
export const THEME_COLOR_NEUTRAL_LIGHT_100 = "#cccccc";
export const THEME_COLOR_NEUTRAL_LIGHT_150 = "#b3b3b3";
export const THEME_COLOR_NEUTRAL_LIGHT_200 = "#9b9b9b";
export const THEME_COLOR_NEUTRAL_LIGHT_250 = "#848484";
export const THEME_COLOR_NEUTRAL_LIGHT_300 = "#6d6d6d";
export const THEME_COLOR_NEUTRAL_LIGHT_350 = "#575757";
export const THEME_COLOR_NEUTRAL_LIGHT_400 = "#424242";
export const THEME_COLOR_NEUTRAL_LIGHT_450 = "#2e2e2e";
export const THEME_COLOR_NEUTRAL_LIGHT_500 = "#1b1b1b";
export const THEME_COLOR_NEUTRAL_DARK_50 = "#191919";
export const THEME_COLOR_NEUTRAL_DARK_100 = "#2c2c2c";
export const THEME_COLOR_NEUTRAL_DARK_150 = "#404040";
export const THEME_COLOR_NEUTRAL_DARK_200 = "#555555";
export const THEME_COLOR_NEUTRAL_DARK_250 = "#6a6a6a";
export const THEME_COLOR_NEUTRAL_DARK_300 = "#818181";
export const THEME_COLOR_NEUTRAL_DARK_350 = "#989898";
export const THEME_COLOR_NEUTRAL_DARK_400 = "#b0b0b0";
export const THEME_COLOR_NEUTRAL_DARK_450 = "#c9c9c9";
export const THEME_COLOR_NEUTRAL_DARK_500 = "#e2e2e2";
export const THEME_COLOR_ACTION_500 = "#95c2ff";
export const THEME_COLOR_ACTION = "#1565C0";
export const THEME_COLOR_ACTION_PRIVATE_500 = "#95c2ff";
export const THEME_COLOR_ERROR_500 = "#ff909a";
export const THEME_COLOR_ERROR = "#E60F41";
export const THEME_COLOR_ERROR_PRIVATE_500 = "#ff909a";
export const THEME_COLOR_WARNING_500 = "#ffc873";
export const THEME_COLOR_WARNING = "#E3660E";
export const THEME_COLOR_WARNING_PRIVATE_500 = "#ffc873";
export const THEME_COLOR_SUCCESS_500 = "#90ffb6";
export const THEME_COLOR_SUCCESS = "#1BA158";
export const THEME_COLOR_SUCCESS_PRIVATE_500 = "#90ffb6";
export const THEME_COLOR_INFORMATION_500 = "#ffffff";
export const THEME_COLOR_INFORMATION = "#1192E8";
export const THEME_COLOR_INFORMATION_PRIVATE_500 = "#a1f4ff";
export const THEME_COLOR_ATTENTION = "#FFC72C";
export const THEME_FONT_FAMILY_DEFAULT = "'British Gas Body', sans-serif";
export const THEME_FONT_FAMILY_MONOSPACE = "monospace";
export const THEME_FONT_FAMILY_LABEL = "'British Gas Body', sans-serif";
export const THEME_FONT_FAMILY_HEADING = "'British Gas Body', sans-serif";
export const THEME_FONT_SIZE_DEFAULT = "1rem";
export const THEME_FONT_SIZE_LABEL = "1rem";
export const THEME_FONT_SIZE_HEADING = "1.5rem";
export const THEME_FONT_WEIGHT_DEFAULT = "400";
export const THEME_FONT_WEIGHT_LABEL = "600";
export const THEME_FONT_WEIGHT_HEADING = "600";
export const THEME_FONT_LINE_LENGTH = "50ch";
export const THEME_SIZE_SM = "1rem";
export const THEME_SIZE_MD = "1.25rem";
export const THEME_SIZE_LG = "1.5rem";
export const THEME_SPACER_ZERO = "0rem";
export const THEME_SPACER_SM = "0.5rem";
export const THEME_SPACER_MD = "1rem";
export const THEME_SPACER_LG = "1.5rem";
export const THEME_SPACER_XL = "2rem";
export const THEME_SPACER_NEGATIVE_SM = "-0.5rem";
export const THEME_SPACER_NEGATIVE_MD = "-1rem";
export const THEME_SPACER_NEGATIVE_LG = "-1.5rem";
export const THEME_SPACER_NEGATIVE_XL = "-2rem";
export const THEME_BORDER_RADIUS_SMALL = "0.125rem";
export const THEME_BORDER_RADIUS_MEDIUM = "0.25rem";
export const THEME_BORDER_RADIUS_LARGE = "0.5rem";
export const THEME_BORDER_RADIUS_HUGE = "1rem";
export const THEME_BORDER_WIDTH_TINY = "0.0625rem";
export const THEME_BORDER_WIDTH_SMALL = "0.125rem";
export const THEME_BORDER_WIDTH_MEDIUM = "0.25rem";
export const THEME_ICON_ERROR = "error";
export const THEME_ICON_INFORMATION = "info";
export const THEME_ICON_SUCCESS = "success";
export const THEME_ICON_WARNING = "warning";
export const VALIDATION_IS_REQUIRED_MESSAGE = "This field is required";
export const VALIDATION_IS_NUMBER_MESSAGE = "Needs to be a number";
export const VALIDATION_IS_INTEGER_MESSAGE = "Needs to be a whole number";
export const VALIDATION_IS_EMAIL_MESSAGE = "Your email does not look right";
export const VALIDATION_MIN_LENGTH_MESSAGE = "Length must be at least $min characters";
export const VALIDATION_MAX_LENGTH_MESSAGE = "Length must be no longer than $max characters";
export const VALIDATION_IS_BETWEEN_MESSAGE = "Length must be between $min and $max characters";
export const VALIDATION_IS_DATE_MESSAGE = "Your date does not look right";
export const VALIDATION_MIN_DATE_MESSAGE = "Date must be on or after $minDate";
export const VALIDATION_MAX_DATE_MESSAGE = "Date must be on or before $maxDate";
export const VALIDATION_HAS_NUMBERS_MESSAGE = "Must include at least one number";
export const VALIDATION_HAS_LETTERS_MESSAGE = "Must include at least one letter";
export const CARD_CONFIG_TYPE = "standard";
export const CARD_COLOR = "#404040";
export const CARD_BACKGROUND_COLOR = "#FFFFFF";
export const CARD_GAP = "1rem";
export const CARD_PADDING_BLOCK = "1rem";
export const CARD_PADDING_INLINE = "1rem";
export const CARD_BORDER_COLOR = "#404040";
export const CARD_BORDER_WIDTH = "2px";
export const CARD_BORDER_RADIUS = "0";
export const CARD_BORDER_STYLE = "solid";
export const CTA_CONFIG_TYPE = "standard";
export const CTA_COLOR = "#FFFFFF";
export const CTA_BACKGROUND_COLOR = "#004ECC";
export const CTA_GAP = "0.5rem";
export const CTA_PADDING_BLOCK = "0.75rem";
export const CTA_PADDING_INLINE = "1.25rem";
export const CTA_BORDER_COLOR = "#004ECC";
export const CTA_BORDER_WIDTH = "0.125rem";
export const CTA_BORDER_RADIUS = "0.25rem";
export const CTA_BORDER_STYLE = "solid";
export const CTA_LOADING_MESSAGE = "Loading...";
export const CTA_LOADING_ICON_NAME = "loading";
export const CTA_LOADING_BACKGROUND_COLOR = "#002F87";
export const CTA_LOADING_BORDER_COLOR = "#002F87";
export const CTA_ICON_NAME = "arrow-right";
export const CTA_ICON_POSITION = "end";
export const CTA_ICON_SIZE = "1.25rem";
export const CTA_LABEL_MIN_WIDTH = "9ch";
export const CTA_LABEL_MAX_WIDTH = "50ch";
export const CTA_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const CTA_HOVER_BACKGROUND_COLOR = "#002F87";
export const CTA_HOVER_BORDER_COLOR = "#002F87";
export const CTA_FOCUS_OUTLINE_COLOR = "#FFC72C";
export const CTA_ACTIVE_BACKGROUND_COLOR = "#002F87";
export const CTA_ACTIVE_BORDER_COLOR = "#002F87";
export const CTA_DISABLED_BACKGROUND_COLOR = "#b0b0b0";
export const CTA_DISABLED_BORDER_COLOR = "#b0b0b0";
export const CTA_DIRECT_ICON_SIZE_VIEWPORT_DEFAULT = "1.5rem";
export const CTA_DIRECT_ICON_SIZE_VIEWPORT_BASKETBALL_COURT = "1.75rem";
export const CTA_DIRECT_ICON_SIZE_VIEWPORT_RUGBY_PITCH = "2rem";
export const CTA_TEXT_GAP = "0.25rem";
export const CTA_TEXT_ICON_SIZE_VIEWPORT_DEFAULT = "1rem";
export const CTA_TEXT_ICON_SIZE_VIEWPORT_BASKETBALL_COURT = "1.125rem";
export const CTA_TEXT_ICON_SIZE_VIEWPORT_RUGBY_PITCH = "1.25rem";
export const DETAIL_CONFIG_TYPE = "standard";
export const DETAIL_TOGGLE_OPEN = "chevron-down";
export const DETAIL_TOGGLE_CLOSE = "chevron-up";
export const DETAIL_TOGGLE_POSITION = "end";
export const DETAIL_TOGGLE_ICON_SIZE = "1.5rem";
export const DETAIL_HEADING_COLOR = "#004ECC";
export const DETAIL_HEADING_BACKGROUND_COLOR = "#FFFFFF";
export const DETAIL_HEADING_GAP = "1rem";
export const DETAIL_HEADING_PADDING_BLOCK = "1rem";
export const DETAIL_HEADING_PADDING_INLINE = "1rem";
export const DETAIL_HEADING_HOVER_COLOR = "#004ECC";
export const DETAIL_HEADING_HOVER_BACKGROUND_COLOR = "#F3F5F7";
export const DETAIL_HEADING_FOCUS_COLOR = "#004ECC";
export const DETAIL_HEADING_FOCUS_BACKGROUND_COLOR = "#FFFFFF";
export const DETAIL_HEADING_FOCUS_OUTLINE_COLOR = "#002F87";
export const DETAIL_CONTENT_COLOR = "#111518";
export const DETAIL_CONTENT_PADDING_BLOCK = "0.5rem";
export const DETAIL_CONTENT_PADDING_INLINE = "1rem";
export const DETAIL_CONTENT_ICON_SPACER = "calc(1rem + 1.5rem + 1rem)";
export const FORM_CONFIG_TYPE = "standard";
export const FORM_ROW_GAP = "1.5rem";
export const ICON_CONFIG_TYPE = "standard";
export const ICON_CONFIG_NAME = "arrow";
export const ICON_CONFIG_CATEGORY = "";
export const ICON_CONFIG_SIZES = [16,32,48,64,72];
export const ICON_CONFIG_URL = "https://www.britishgas.co.uk/nucleus/assets/british-gas/icons/(name).svg";
export const ICON_FILL = "currentColor";
export const ICON_SYSTEM_ERROR = "error";
export const ICON_SYSTEM_INFO = "info";
export const ICON_SYSTEM_SUCCESS = "success";
export const ICON_SYSTEM_WARNING = "warning";
export const IMAGE_CONFIG_TYPE = "standard";
export const IMAGE_CONFIG_RATIOS = ["1 / 1","4 / 3","16 / 9"];
export const IMAGE_CONFIG_RATIO = "";
export const IMAGE_CONFIG_PLACEHOLDER = "";
export const INPUTTER_CONFIG_TYPE = "standard";
export const INPUTTER_CONFIG_DISABLED = true;
export const INPUTTER_FIELD_COLOR = "#111518";
export const INPUTTER_FIELD_BACKGROUND_COLOR = "#FFFFFF";
export const INPUTTER_FIELD_FONT_FAMILY = "'British Gas Body', sans-serif";
export const INPUTTER_FIELD_FONT_SIZE = "1rem";
export const INPUTTER_FIELD_PADDING_BLOCK_START = "0.5rem";
export const INPUTTER_FIELD_PADDING_BLOCK_END = "0.5rem";
export const INPUTTER_FIELD_PADDING_INLINE_START = "1rem";
export const INPUTTER_FIELD_PADDING_INLINE_END = "1rem";
export const INPUTTER_FIELD_BORDER_COLOR = "#435460";
export const INPUTTER_FIELD_BORDER_RADIUS = "0.25rem";
export const INPUTTER_FIELD_BORDER_STYLE = "solid";
export const INPUTTER_FIELD_BORDER_WIDTH = "2px";
export const INPUTTER_FIELD_LINE_HEIGHT = "inherit";
export const INPUTTER_FIELD_ICON_SIZE = "1.5rem";
export const INPUTTER_FIELD_ICON_SPACER = "calc(0.5rem + 1.5rem + 0.5rem)";
export const INPUTTER_FIELD_DATE_ICON = "calendar";
export const INPUTTER_FIELD_SELECT_ICON = "chevronDown";
export const INPUTTER_FIELD_SELECT_MIN_WIDTH = "10ch";
export const INPUTTER_FIELD_SEARCH_ICON = "search";
export const INPUTTER_FIELD_TEXT_MAX_WIDTH = "48ch";
export const INPUTTER_FIELD_EMAIL_MAX_WIDTH = "36ch";
export const INPUTTER_FIELD_TEL_MAX_WIDTH = "16ch";
export const INPUTTER_FIELD_PASSWORD_MAX_WIDTH = "22rem";
export const INPUTTER_FIELD_NUMBER_MAX_WIDTH = "8ch";
export const INPUTTER_FIELD_GIVEN_NAME_MAX_WIDTH = "12ch";
export const INPUTTER_FIELD_FAMILY_NAME_MAX_WIDTH = "12ch";
export const INPUTTER_FIELD_POSTAL_CODE_MAX_WIDTH = "8ch";
export const INPUTTER_MULTIPLE_BACKGROUND_COLOR = "#FFFFFF";
export const INPUTTER_MULTIPLE_ROW_GAP = "0.5rem";
export const INPUTTER_MULTIPLE_SIZE = "2em";
export const INPUTTER_MULTIPLE_BORDER_COLOR = "#435460";
export const INPUTTER_MULTIPLE_LABEL_PADDING_INLINE_START = "0.5rem";
export const INPUTTER_MULTIPLE_LABEL_PADDING_INLINE_END = "0.5rem";
export const INPUTTER_MULTIPLE_LABEL_PADDING_BLOCK_START = "0.5em";
export const INPUTTER_MULTIPLE_LABEL_PADDING_BLOCK_END = "0.5em";
export const INPUTTER_MULTIPLE_RADIO_DOT_COLOR = "#004ECC";
export const INPUTTER_MULTIPLE_RADIO_DOT_SIZE = "0.5em";
export const INPUTTER_MULTIPLE_CHECKBOX_CHECK_WIDTH = "0.625em";
export const INPUTTER_MULTIPLE_CHECKBOX_CHECK_HEIGHT = "1.125em";
export const INPUTTER_MULTIPLE_CHECKBOX_CHECK_SIZE = "0.25em";
export const INPUTTER_MULTIPLE_CHECKBOX_CHECK_COLOR = "#004ECC";
export const INPUTTER_MULTIPLE_CHECKBOX_BORDER_RADIUS = "0.25rem";
export const INPUTTER_MULTIPLE_HOVER_BACKGROUND_COLOR = "#C3CED5";
export const INPUTTER_MULTIPLE_HOVER_BORDER_COLOR = "#111518";
export const INPUTTER_LABEL_COLOR = "#111518";
export const INPUTTER_LABEL_MARGIN_BLOCK_START = 0;
export const INPUTTER_LABEL_MARGIN_BLOCK_END = "0.5rem";
export const INPUTTER_LABEL_LINE_LENGTH = "50ch";
export const INPUTTER_PLACEHOLDER_COLOR = "#b0b0b0";
export const INPUTTER_MASK_PRIVATE_COLOR = "#767676";
export const INPUTTER_MASK_COLOR = "#767676";
export const INPUTTER_MASK_FONT_FAMILY = "Courier New, Courier, monospace";
export const INPUTTER_MASK_FONT_WEIGHT = "bold";
export const INPUTTER_INTERACTIVE_ICON_COLOR = "#004ECC";
export const INPUTTER_HOVER_PRIVATE_COLOR = "#000000";
export const INPUTTER_HOVER_COLOR = "#111518";
export const INPUTTER_HOVER_BORDER_COLOR = "#111518";
export const INPUTTER_FOCUS_COLOR = "#111518";
export const INPUTTER_FOCUS_BORDER_COLOR = "#002F87";
export const INPUTTER_FOCUS_OUTLINE_COLOR = "#002F87";
export const INPUTTER_FOCUS_OUTLINE_OFFSET = 0;
export const INPUTTER_FOCUS_OUTLINE_STYLE = "solid";
export const INPUTTER_FOCUS_OUTLINE_WIDTH = "0.125rem";
export const INPUTTER_DISABLED_COLOR = "#b0b0b0";
export const INPUTTER_DISABLED_BORDER_COLOR = "#b0b0b0";
export const INPUTTER_DISABLED_BACKGROUND_PRIVATE_COLOR = "#e2e2e2";
export const INPUTTER_DISABLED_BACKGROUND_COLOR = "#e2e2e2";
export const INPUTTER_DISABLED_PLACEHOLDER_COLOR = "#b0b0b0";
export const INPUTTER_VALIDATION_FONT_SIZE = "1rem";
export const INPUTTER_VALIDATION_MARGIN_BLOCK = "0.5rem";
export const INPUTTER_VALIDATION_GAP = "0.25rem";
export const INPUTTER_VALIDATION_ICON_SIZE = "1.5rem";
export const INPUTTER_VALIDATION_WARNING_COLOR = "#E3660E";
export const INPUTTER_VALIDATION_WARNING_ICON = "warning";
export const INPUTTER_DETAIL_COLOR = "#111518";
export const INPUTTER_DETAIL_HOVER_COLOR = "#111518";
export const INPUTTER_DETAIL_HEADING_FONT_SIZE = "1rem";
export const INPUTTER_DETAIL_HEADING_MARGIN_BLOCK_START = 0;
export const INPUTTER_DETAIL_HEADING_MARGIN_BLOCK_END = "1rem";
export const INPUTTER_DETAIL_HEADING_GAP = 0;
export const INPUTTER_DETAIL_HEADING_LINE_LENGTH = "50ch";
export const INPUTTER_DETAIL_CONTENT_FONT_SIZE = "0.889rem";
export const INPUTTER_DETAIL_CONTENT_MARGIN_BLOCK_START = 0;
export const INPUTTER_DETAIL_CONTENT_MARGIN_BLOCK_END = "1rem";
export const INPUTTER_DETAIL_CONTENT_PADDING_INLINE = "0.5rem";
export const INPUTTER_DETAIL_CONTENT_LINE_LENGTH = "50ch";
export const INPUTTER_DETAIL_ICON_SIZE = "1.25rem";
export const INPUTTER_DETAIL_TOGGLE_OPEN = "chevronDown";
export const INPUTTER_DETAIL_TOGGLE_CLOSE = "chevronUp";
export const INPUTTER_DETAIL_TOGGLE_POSITION = "end";
export const INPUTTER_DETAIL_FOCUS_OUTLINE_COLOR = "#002F87";
export const INPUTTER_DETAIL_FOCUS_OUTLINE_OFFSET = 0;
export const INPUTTER_DETAIL_FOCUS_OUTLINE_STYLE = "solid";
export const INPUTTER_DETAIL_FOCUS_OUTLINE_WIDTH = "0.25rem";
export const INPUTTER_DETAIL_BORDER_PRIVATE_COLOR = "#8e9396";
export const INPUTTER_DETAIL_BORDER_COLOR = "#C3CED5";
export const INPUTTER_DETAIL_BORDER_STYLE = "solid";
export const INPUTTER_DETAIL_BORDER_WIDTH = "3px";
export const SVG_CONFIG_CACHE = "bg-ns-04";
export const ASSET_FONT_BODY_NAME = "British Gas Body";
export const ASSET_FONT_BODY_UNICODE_RANGE = "U+0020-22,U+0025-003B,U+003F-005A,U+005F-007A,U+007C,U+00A0,U+00A3,U+00A9,U+2013-201D,U+FB00-FB04";
export const ASSET_FONT_BODY_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Body.woff2";
export const ASSET_FONT_BODY_EXTENDED_NAME = "British Gas Body";
export const ASSET_FONT_BODY_EXTENDED_UNICODE_RANGE = "U+0023-0024,U+003C-003E,U+005B-005E,U+007B,U+00A1-A2,U+00A4-A8,U+00AA-2012,U+201E-FAFF";
export const ASSET_FONT_BODY_EXTENDED_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Body-extended.woff2";
export const ASSET_FONT_MEDIUM_NAME = "British Gas Medium";
export const ASSET_FONT_MEDIUM_UNICODE_RANGE = "U+0020-22,U+0025-003B,U+003F-005A,U+005F-007A,U+007C,U+00A0,U+00A3,U+00A9,U+2013-201D,U+FB00-FB04";
export const ASSET_FONT_MEDIUM_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Medium.woff2";
export const ASSET_FONT_MEDIUM_EXTENDED_NAME = "British Gas Medium";
export const ASSET_FONT_MEDIUM_EXTENDED_UNICODE_RANGE = "U+0023-0024,U+003C-003E,U+005B-005E,U+007B,U+00A1-A2,U+00A4-A8,U+00AA-2012,U+201E-FAFF";
export const ASSET_FONT_MEDIUM_EXTENDED_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Medium-extended.woff2";
export const ASSET_FONT_SUBHEAD_NAME = "British Gas Subhead";
export const ASSET_FONT_SUBHEAD_UNICODE_RANGE = "U+0020-22,U+0025-003B,U+003F-005A,U+005F-007A,U+007C,U+00A0,U+00A3,U+00A9,U+2013-201D,U+FB00-FB04";
export const ASSET_FONT_SUBHEAD_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Subhead.woff2";
export const ASSET_FONT_SUBHEAD_EXTENDED_NAME = "British Gas Subhead";
export const ASSET_FONT_SUBHEAD_EXTENDED_UNICODE_RANGE = "U+0023-0024,U+003C-003E,U+005B-005E,U+007B,U+00A1-A2,U+00A4-A8,U+00AA-2012,U+201E-FAFF";
export const ASSET_FONT_SUBHEAD_EXTENDED_WOFF2 = "https://www.britishgas.co.uk/nucleus/fonts/BritishGas-Subhead-extended.woff2";
export const BORDER_SIZE_1PX = "0.0625rem";
export const BORDER_SIZE_2PX = "0.125rem";
export const BORDER_SIZE_4PX = "0.25rem";
export const BORDER_SIZE_8PX = "0.5rem";
export const BORDER_SIZE_16PX = "1rem";
export const COLOR_PRIMARY_CYAN = "#0093F5";
export const COLOR_PRIMARY_LIME = "#7FCC00";
export const COLOR_PRIMARY_NAVY = "#002F87";
export const COLOR_SECONDARY_BLUE = "#004ECC";
export const COLOR_SECONDARY_FOREST = "#00A33E";
export const COLOR_SECONDARY_SLATE = "#111518";
export const COLOR_SECONDARY_ORANGE = "#FF5900";
export const COLOR_SECONDARY_RED = "#D50032";
export const COLOR_SECONDARY_YELLOW = "#FFC72C";
export const COLOR_GREYSCALE_WHITE = "#FFFFFF";
export const COLOR_GREYSCALE_LIGHT = "#F3F5F7";
export const COLOR_GREYSCALE_MEDIUM = "#C3CED5";
export const COLOR_GREYSCALE_DARK = "#435460";
export const COLOR_SYSTEM_INFORMATION = "#1192E8";
export const COLOR_SYSTEM_SUCCESS = "#1BA158";
export const COLOR_SYSTEM_ATTENTION = "#FFC72C";
export const COLOR_SYSTEM_WARNING = "#E3660E";
export const COLOR_SYSTEM_DANGER = "#E60F41";
export const COLOR_SYSTEM_NEUTRAL = "#767676";
export const COLOR_SYSTEM_FOCUS = "#002F87";
export const COLOR_CYAN_100 = "#EBF7FF";
export const COLOR_CYAN_300 = "#99D6FF";
export const COLOR_CYAN_500 = "#47B6FF";
export const COLOR_CYAN_600 = "#0093F5";
export const COLOR_CYAN_700 = "#0062A3";
export const COLOR_CYAN_800 = "#003152";
export const COLOR_CYAN_900 = "#001929";
export const COLOR_NAVY_100 = "#EBF3FF";
export const COLOR_NAVY_300 = "#99C0FF";
export const COLOR_NAVY_500 = "#1F74FF";
export const COLOR_NAVY_600 = "#004ECC";
export const COLOR_NAVY_700 = "#002F87";
export const COLOR_NAVY_800 = "#001F52";
export const COLOR_NAVY_900 = "#001029";
export const COLOR_LIME_100 = "#F7FFEB";
export const COLOR_LIME_300 = "#C9FF70";
export const COLOR_LIME_500 = "#AAFF1F";
export const COLOR_LIME_600 = "#7FCC00";
export const COLOR_LIME_700 = "#4C7A00";
export const COLOR_LIME_800 = "#335200";
export const COLOR_LIME_900 = "#192900";
export const COLOR_SLATE_100 = "#F3F5F7";
export const COLOR_SLATE_200 = "#C3CED5";
export const COLOR_SLATE_300 = "#91A5B3";
export const COLOR_SLATE_400 = "#7B92A3";
export const COLOR_SLATE_500 = "#435460";
export const COLOR_SLATE_600 = "#2A353D";
export const COLOR_SLATE_700 = "#212A30";
export const COLOR_SLATE_800 = "#111518";
export const COLOR_ORANGE_100 = "#FFF5EB";
export const COLOR_ORANGE_300 = "#FFCA99";
export const COLOR_ORANGE_500 = "#FF9F47";
export const COLOR_ORANGE_600 = "#FF5900";
export const COLOR_ORANGE_700 = "#A34E00";
export const COLOR_ORANGE_800 = "#522700";
export const COLOR_ORANGE_900 = "#291400";
export const COLOR_FOREST_100 = "#EBFFF3";
export const COLOR_FOREST_300 = "#70FFA6";
export const COLOR_FOREST_500 = "#00F55D";
export const COLOR_FOREST_600 = "#00A33E";
export const COLOR_FOREST_700 = "#007A2F";
export const COLOR_FOREST_800 = "#00521F";
export const COLOR_FOREST_900 = "#002910";
export const COLOR_RED_100 = "#FFEBF0";
export const COLOR_RED_300 = "#FF99B1";
export const COLOR_RED_500 = "#E60F41";
export const COLOR_RED_600 = "#D50032";
export const COLOR_RED_700 = "#A30026";
export const COLOR_RED_800 = "#520013";
export const COLOR_RED_900 = "#29000A";
export const COLOR_YELLOW_100 = "#FFF9EA";
export const COLOR_YELLOW_300 = "#FFEEC0";
export const COLOR_YELLOW_500 = "#FFE395";
export const COLOR_YELLOW_600 = "#FFC72C";
export const COLOR_YELLOW_700 = "#E5B328";
export const COLOR_YELLOW_800 = "#CC9F23";
export const FONT_FAMILY_REGULAR = "'British Gas Body', sans-serif";
export const FONT_FAMILY_BOLD = "'British Gas Medium', sans-serif";
export const FONT_FAMILY_MARKETING = "'British Gas Subhead', sans-serif";
export const FONT_FAMILY_DEFAULT = "'British Gas Body', sans-serif";
export const FONT_FAMILY_PARAGRAPH = "'British Gas Body', sans-serif";
export const FONT_FAMILY_LABEL = "'British Gas Body', sans-serif";
export const FONT_FAMILY_HEADING = "'British Gas Medium', sans-serif";
export const FONT_FAMILY_ACTION = "'British Gas Medium', sans-serif";
export const FONT_FAMILY_MONOSPACE = "monospace";
export const FONT_SIZE_BASE = "1rem";
export const FONT_SIZE_HEADING_ONE_SMALL = "1.8rem";
export const FONT_SIZE_HEADING_ONE_MEDIUM = "2.563rem";
export const FONT_SIZE_HEADING_ONE_LARGE = "3.583rem";
export const FONT_SIZE_HEADING_TWO_SMALL = "1.683rem";
export const FONT_SIZE_HEADING_TWO_MEDIUM = "2.281rem";
export const FONT_SIZE_HEADING_TWO_LARGE = "2.488rem";
export const FONT_SIZE_HEADING_THREE_SMALL = "1.383rem";
export const FONT_SIZE_HEADING_THREE_MEDIUM = "1.602rem";
export const FONT_SIZE_HEADING_THREE_LARGE = "1.728rem";
export const FONT_SIZE_HEADING_FOUR_SMALL = "1.296rem";
export const FONT_SIZE_HEADING_FOUR_MEDIUM = "1.424rem";
export const FONT_SIZE_HEADING_FOUR_LARGE = "1.44rem";
export const FONT_SIZE_HEADING_FIVE_SMALL = "1.215rem";
export const FONT_SIZE_HEADING_FIVE_MEDIUM = "1.266rem";
export const FONT_SIZE_HEADING_FIVE_LARGE = "1.266rem";
export const FONT_SIZE_HEADING_SIX_SMALL = "1.215rem";
export const FONT_SIZE_HEADING_SIX_MEDIUM = "1.266rem";
export const FONT_SIZE_HEADING_SIX_LARGE = "1.266rem";
export const FONT_SIZE_MARKETING_SMALL = "2.056rem";
export const FONT_SIZE_MARKETING_MEDIUM = "2.884rem";
export const FONT_SIZE_MARKETING_LARGE = "4.3rem";
export const FONT_SIZE_PARAGRAPH_LARGE_SMALL = "1.476rem";
export const FONT_SIZE_PARAGRAPH_LARGE_MEDIUM = "1.602rem";
export const FONT_SIZE_PARAGRAPH_LARGE_LARGE = "1.602rem";
export const FONT_SIZE_PARAGRAPH_FEATURE_SMALL = "1.215rem";
export const FONT_SIZE_PARAGRAPH_FEATURE_MEDIUM = "1.424rem";
export const FONT_SIZE_PARAGRAPH_FEATURE_LARGE = "1.424rem";
export const FONT_SIZE_PARAGRAPH_NORMAL_SMALL = "1.067rem";
export const FONT_SIZE_PARAGRAPH_NORMAL_MEDIUM = "1.125rem";
export const FONT_SIZE_PARAGRAPH_NORMAL_LARGE = "1.125rem";
export const FONT_SIZE_PARAGRAPH_SMALL_SMALL = "1rem";
export const FONT_SIZE_PARAGRAPH_SMALL_MEDIUM = "1.067rem";
export const FONT_SIZE_PARAGRAPH_SMALL_LARGE = "1.067rem";
export const FONT_SIZE_PARAGRAPH_CAPTION_SMALL = "0.889rem";
export const FONT_SIZE_PARAGRAPH_CAPTION_MEDIUM = "0.889rem";
export const FONT_SIZE_PARAGRAPH_CAPTION_LARGE = "0.889rem";
export const FONT_SIZE_ACTION_SMALL = "1rem";
export const FONT_SIZE_ACTION_MEDIUM = "1.067rem";
export const FONT_SIZE_ACTION_LARGE = "1.067rem";
export const FONT_WEIGHT_NORMAL = "400";
export const FONT_WEIGHT_DEFAULT = "400";
export const FONT_WEIGHT_LABEL = "400";
export const FONT_WEIGHT_PARAGRAPH = "400";
export const FONT_WEIGHT_HEADING = "400";
export const FONT_WEIGHT_ACTION = "400";
export const FONT_LINE_HEIGHT_PARAGRAPH = "1.5";
export const FONT_LINE_HEIGHT_HEADING = "1.2";
export const FONT_LINE_HEIGHT_ACTION = "1.5";
export const FONT_LINE_LENGTH = "50ch";
export const FONT_LETTER_SPACING_NORMAL = "normal";
export const FONT_LETTER_SPACING_PARAGRAPH = "-0.013em";
export const FONT_LETTER_SPACING_HEADING = "-0.0145em";
export const FONT_LETTER_SPACING_ACTION = "-0.0145em";
export const FONT_UNICODE_RANGE_SUBSET = "U+0020-22,U+0025-003B,U+003F-005A,U+005F-007A,U+007C,U+00A0,U+00A3,U+00A9,U+2013-201D,U+FB00-FB04";
export const FONT_UNICODE_RANGE_EXTENDED = "U+0023-0024,U+003C-003E,U+005B-005E,U+007B,U+00A1-A2,U+00A4-A8,U+00AA-2012,U+201E-FAFF";
export const LAYOUT_WIDTH = "1440px";
export const LAYOUT_GUTTER = "5%";
export const LAYOUT_WHOLE = "100%";
export const LAYOUT_HALF = "50%";
export const LAYOUT_ONE_THIRD = "33.333%";
export const LAYOUT_ONE_QUARTER = "25%";
export const LAYOUT_TWO_THIRDS = "66.666%";
export const LAYOUT_THREE_QUARTERS = "75%";
export const LAYOUT_TWO_FIFTHS = "40%";
export const LAYOUT_THREE_FIFTHS = "60%";
export const LAYOUT_PANEL_SPACER_BLOCK_VIEWPORT_DEFAULT = "2rem";
export const LAYOUT_PANEL_SPACER_BLOCK_VIEWPORT_BASKETBALL_COURT = "3rem";
export const LAYOUT_PANEL_SPACER_BLOCK_VIEWPORT_RUGBY_PITCH = "4rem";
export const LAYOUT_PANEL_GAP_VIEWPORT_DEFAULT = "1.5rem";
export const LAYOUT_PANEL_GAP_VIEWPORT_BASKETBALL_COURT = "2rem";
export const LAYOUT_PANEL_GAP_VIEWPORT_RUGBY_PITCH = "2.25rem";
export const MODULAR_BASE = "1rem";
export const MODULAR_MINOR_SECOND_10 = "2.056rem";
export const MODULAR_MINOR_SECOND = "1.067rem";
export const MODULAR_MINOR_SECOND_01 = "1.138rem";
export const MODULAR_MINOR_SECOND_02 = "1.215rem";
export const MODULAR_MINOR_SECOND_03 = "1.296rem";
export const MODULAR_MINOR_SECOND_04 = "1.383rem";
export const MODULAR_MINOR_SECOND_05 = "1.476rem";
export const MODULAR_MINOR_SECOND_06 = "1.575rem";
export const MODULAR_MINOR_SECOND_07 = "1.683rem";
export const MODULAR_MINOR_SECOND_08 = "1.8rem";
export const MODULAR_MINOR_SECOND_09 = "1.924rem";
export const MODULAR_MINOR_SECOND_NEGATIVE_01 = "0.937rem";
export const MODULAR_MAJOR_SECOND_10 = "3.656rem";
export const MODULAR_MAJOR_SECOND = "1.125rem";
export const MODULAR_MAJOR_SECOND_01 = "1.266rem";
export const MODULAR_MAJOR_SECOND_02 = "1.424rem";
export const MODULAR_MAJOR_SECOND_03 = "1.602rem";
export const MODULAR_MAJOR_SECOND_04 = "1.802rem";
export const MODULAR_MAJOR_SECOND_05 = "2.027rem";
export const MODULAR_MAJOR_SECOND_06 = "2.281rem";
export const MODULAR_MAJOR_SECOND_07 = "2.563rem";
export const MODULAR_MAJOR_SECOND_08 = "2.884rem";
export const MODULAR_MAJOR_SECOND_09 = "3.248rem";
export const MODULAR_MAJOR_SECOND_NEGATIVE_01 = "0.889rem";
export const MODULAR_MINOR_THIRD_10 = "7.43rem";
export const MODULAR_MINOR_THIRD = "1.2rem";
export const MODULAR_MINOR_THIRD_01 = "1.44rem";
export const MODULAR_MINOR_THIRD_02 = "1.728rem";
export const MODULAR_MINOR_THIRD_03 = "2.074rem";
export const MODULAR_MINOR_THIRD_04 = "2.488rem";
export const MODULAR_MINOR_THIRD_05 = "2.986rem";
export const MODULAR_MINOR_THIRD_06 = "3.583rem";
export const MODULAR_MINOR_THIRD_07 = "4.3rem";
export const MODULAR_MINOR_THIRD_08 = "5.16rem";
export const MODULAR_MINOR_THIRD_09 = "6.192rem";
export const MODULAR_MINOR_THIRD_NEGATIVE_01 = "0.833rem";
export const SCHEME_TONE_100_NAME = "100";
export const SCHEME_TONE_100_DESCRIPTION = "Light tones";
export const SCHEME_TONE_100_HEADING_COLOR = "#002F87";
export const SCHEME_TONE_100_FOREGROUND_COLOR = "#111518";
export const SCHEME_TONE_100_FOCUS_OUTLINE_COLOR = "#002F87";
export const SCHEME_TONE_100_ACTION_COLOR = "#004ECC";
export const SCHEME_TONE_100_ACTION_HOVER_COLOR = "#002F87";
export const SCHEME_TONE_400_NAME = "400";
export const SCHEME_TONE_400_DESCRIPTION = "Mid tones";
export const SCHEME_TONE_400_HEADING_COLOR = "#001F52";
export const SCHEME_TONE_400_FOREGROUND_COLOR = "#111518";
export const SCHEME_TONE_400_FOCUS_OUTLINE_COLOR = "#002F87";
export const SCHEME_TONE_400_ACTION_COLOR = "#001F52";
export const SCHEME_TONE_400_ACTION_HOVER_COLOR = "#111518";
export const SCHEME_TONE_900_NAME = "900";
export const SCHEME_TONE_900_DESCRIPTION = "Dark tones";
export const SCHEME_TONE_900_HEADING_COLOR = "#FFFFFF";
export const SCHEME_TONE_900_FOREGROUND_COLOR = "#FFFFFF";
export const SCHEME_TONE_900_FOCUS_OUTLINE_COLOR = "#FFC72C";
export const SCHEME_TONE_900_ACTION_COLOR = "#99D6FF";
export const SCHEME_TONE_900_ACTION_HOVER_COLOR = "#FFFFFF";
export const SCHEME_CYAN_NAME = "cyan";
export const SCHEME_CYAN_BACKGROUND_COLOR = "#0093F5";
export const SCHEME_CYAN_LOWLIGHT_COLOR = "#47B6FF";
export const SCHEME_CYAN_HIGHLIGHT_COLOR = "#99D6FF";
export const SCHEME_CYAN_TONE = "400";
export const SCHEME_CYAN_KEYLINE = "true";
export const SCHEME_CYAN_LIGHT_NAME = "cyan-light";
export const SCHEME_CYAN_LIGHT_BACKGROUND_COLOR = "#EBF7FF";
export const SCHEME_CYAN_LIGHT_LOWLIGHT_COLOR = "#99D6FF";
export const SCHEME_CYAN_LIGHT_HIGHLIGHT_COLOR = "#0093F5";
export const SCHEME_CYAN_LIGHT_TONE = "100";
export const SCHEME_LIME_NAME = "lime";
export const SCHEME_LIME_BACKGROUND_COLOR = "#7FCC00";
export const SCHEME_LIME_LOWLIGHT_COLOR = "#AAFF1F";
export const SCHEME_LIME_HIGHLIGHT_COLOR = "#C9FF70";
export const SCHEME_LIME_TONE = "400";
export const SCHEME_LIME_KEYLINE = "true";
export const SCHEME_LIME_LIGHT_NAME = "lime-light";
export const SCHEME_LIME_LIGHT_BACKGROUND_COLOR = "#F7FFEB";
export const SCHEME_LIME_LIGHT_LOWLIGHT_COLOR = "#C9FF70";
export const SCHEME_LIME_LIGHT_HIGHLIGHT_COLOR = "#7FCC00";
export const SCHEME_LIME_LIGHT_TONE = "100";
export const SCHEME_NAVY_NAME = "navy";
export const SCHEME_NAVY_BACKGROUND_COLOR = "#002F87";
export const SCHEME_NAVY_LOWLIGHT_COLOR = "#001F52";
export const SCHEME_NAVY_HIGHLIGHT_COLOR = "#004ECC";
export const SCHEME_NAVY_TONE = "900";
export const SCHEME_NAVY_KEYLINE = "true";
export const SCHEME_NAVY_LIGHT_NAME = "navy-light";
export const SCHEME_NAVY_LIGHT_BACKGROUND_COLOR = "#EBF3FF";
export const SCHEME_NAVY_LIGHT_LOWLIGHT_COLOR = "#99C0FF";
export const SCHEME_NAVY_LIGHT_HIGHLIGHT_COLOR = "#004ECC";
export const SCHEME_NAVY_LIGHT_TONE = "100";
export const SCHEME_NAVY_DARK_NAME = "navy-dark";
export const SCHEME_NAVY_DARK_BACKGROUND_COLOR = "#001F52";
export const SCHEME_NAVY_DARK_LOWLIGHT_COLOR = "#001029";
export const SCHEME_NAVY_DARK_HIGHLIGHT_COLOR = "#002F87";
export const SCHEME_NAVY_DARK_TONE = "900";
export const SCHEME_BLUE_NAME = "blue";
export const SCHEME_BLUE_BACKGROUND_COLOR = "#004ECC";
export const SCHEME_BLUE_LOWLIGHT_COLOR = "#002F87";
export const SCHEME_BLUE_HIGHLIGHT_COLOR = "#1F74FF";
export const SCHEME_BLUE_TONE = "900";
export const SCHEME_BLUE_KEYLINE = "true";
export const SCHEME_FOREST_NAME = "forest";
export const SCHEME_FOREST_BACKGROUND_COLOR = "#00A33E";
export const SCHEME_FOREST_LOWLIGHT_COLOR = "#00F55D";
export const SCHEME_FOREST_HIGHLIGHT_COLOR = "#70FFA6";
export const SCHEME_FOREST_TONE = "400";
export const SCHEME_FOREST_KEYLINE = "true";
export const SCHEME_FOREST_LIGHT_NAME = "forest-light";
export const SCHEME_FOREST_LIGHT_BACKGROUND_COLOR = "#EBFFF3";
export const SCHEME_FOREST_LIGHT_LOWLIGHT_COLOR = "#70FFA6";
export const SCHEME_FOREST_LIGHT_HIGHLIGHT_COLOR = "#00A33E";
export const SCHEME_FOREST_LIGHT_TONE = "100";
export const SCHEME_SLATE_NAME = "slate";
export const SCHEME_SLATE_BACKGROUND_COLOR = "#111518";
export const SCHEME_SLATE_LOWLIGHT_COLOR = "#2A353D";
export const SCHEME_SLATE_HIGHLIGHT_COLOR = "#435460";
export const SCHEME_SLATE_TONE = "900";
export const SCHEME_SLATE_KEYLINE = "true";
export const SCHEME_ORANGE_NAME = "orange";
export const SCHEME_ORANGE_BACKGROUND_COLOR = "#FF5900";
export const SCHEME_ORANGE_LOWLIGHT_COLOR = "#FF9F47";
export const SCHEME_ORANGE_HIGHLIGHT_COLOR = "#FFCA99";
export const SCHEME_ORANGE_TONE = "400";
export const SCHEME_ORANGE_KEYLINE = "true";
export const SCHEME_ORANGE_LIGHT_NAME = "orange-light";
export const SCHEME_ORANGE_LIGHT_BACKGROUND_COLOR = "#FFF5EB";
export const SCHEME_ORANGE_LIGHT_LOWLIGHT_COLOR = "#FFCA99";
export const SCHEME_ORANGE_LIGHT_HIGHLIGHT_COLOR = "#FF5900";
export const SCHEME_ORANGE_LIGHT_TONE = "100";
export const SCHEME_RED_NAME = "red";
export const SCHEME_RED_BACKGROUND_COLOR = "#D50032";
export const SCHEME_RED_LOWLIGHT_COLOR = "#E60F41";
export const SCHEME_RED_HIGHLIGHT_COLOR = "#FF99B1";
export const SCHEME_RED_TONE = "900";
export const SCHEME_RED_KEYLINE = "true";
export const SCHEME_YELLOW_NAME = "yellow";
export const SCHEME_YELLOW_BACKGROUND_COLOR = "#FFC72C";
export const SCHEME_YELLOW_LOWLIGHT_COLOR = "#FFE395";
export const SCHEME_YELLOW_HIGHLIGHT_COLOR = "#CC9F23";
export const SCHEME_YELLOW_TONE = "100";
export const SCHEME_YELLOW_KEYLINE = "true";
export const SCHEME_YELLOW_LIGHT_NAME = "yellow-light";
export const SCHEME_YELLOW_LIGHT_BACKGROUND_COLOR = "#FFF9EA";
export const SCHEME_YELLOW_LIGHT_LOWLIGHT_COLOR = "#FFEEC0";
export const SCHEME_YELLOW_LIGHT_HIGHLIGHT_COLOR = "#FFC72C";
export const SCHEME_YELLOW_LIGHT_TONE = "100";
export const SCHEME_WHITE_NAME = "white";
export const SCHEME_WHITE_BACKGROUND_COLOR = "#FFFFFF";
export const SCHEME_WHITE_LOWLIGHT_COLOR = "#F3F5F7";
export const SCHEME_WHITE_HIGHLIGHT_COLOR = "#C3CED5";
export const SCHEME_WHITE_TONE = "100";
export const SCHEME_GREY_LIGHT_NAME = "grey-light";
export const SCHEME_GREY_LIGHT_BACKGROUND_COLOR = "#F3F5F7";
export const SCHEME_GREY_LIGHT_LOWLIGHT_COLOR = "#FFFFFF";
export const SCHEME_GREY_LIGHT_HIGHLIGHT_COLOR = "#C3CED5";
export const SCHEME_GREY_LIGHT_TONE = "100";
export const SIZE_16PX = "1rem";
export const SIZE_18PX = "1.125rem";
export const SIZE_20PX = "1.25rem";
export const SIZE_24PX = "1.5rem";
export const SIZE_28PX = "1.75rem";
export const SIZE_32PX = "2rem";
export const SIZE_36PX = "2.25rem";
export const SIZE_48PX = "3rem";
export const SIZE_56PX = "3.5rem";
export const SIZE_64PX = "4rem";
export const SIZE_72PX = "4.5rem";
export const SIZE_92PX = "5.75rem";
export const SIZE_128PX = "8rem";
export const SIZE_144PX = "9rem";
export const SPACER_4PX = "0.25rem";
export const SPACER_8PX = "0.5rem";
export const SPACER_12PX = "0.75rem";
export const SPACER_16PX = "1rem";
export const SPACER_20PX = "1.25rem";
export const SPACER_24PX = "1.5rem";
export const SPACER_28PX = "1.75rem";
export const SPACER_32PX = "2rem";
export const SPACER_36PX = "2.25rem";
export const SPACER_40PX = "2.5rem";
export const SPACER_48PX = "3rem";
export const SPACER_64PX = "4rem";
export const SPACER_144PX = "9rem";
export const TYPOGRAPHY_HEADING_ONE_NAME = "h1";
export const TYPOGRAPHY_HEADING_ONE_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_HEADING_ONE_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_ONE_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_ONE_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_SMALL_FONT_SIZE = "1.8rem";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_MEDIUM_FONT_SIZE = "2.563rem";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_MEDIUM_SPACER = "1.5rem";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_LARGE_FONT_SIZE = "3.583rem";
export const TYPOGRAPHY_HEADING_ONE_VIEWPORT_LARGE_SPACER = "2rem";
export const TYPOGRAPHY_HEADING_TWO_NAME = "h2";
export const TYPOGRAPHY_HEADING_TWO_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_HEADING_TWO_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_TWO_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_TWO_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_SMALL_FONT_SIZE = "1.683rem";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_MEDIUM_FONT_SIZE = "2.281rem";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_MEDIUM_SPACER = "1.5rem";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_LARGE_FONT_SIZE = "2.488rem";
export const TYPOGRAPHY_HEADING_TWO_VIEWPORT_LARGE_SPACER = "2rem";
export const TYPOGRAPHY_HEADING_THREE_NAME = "h3";
export const TYPOGRAPHY_HEADING_THREE_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_HEADING_THREE_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_THREE_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_THREE_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_SMALL_FONT_SIZE = "1.383rem";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_MEDIUM_FONT_SIZE = "1.602rem";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_MEDIUM_SPACER = "1.25rem";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_LARGE_FONT_SIZE = "1.728rem";
export const TYPOGRAPHY_HEADING_THREE_VIEWPORT_LARGE_SPACER = "1.5rem";
export const TYPOGRAPHY_HEADING_FOUR_NAME = "h4";
export const TYPOGRAPHY_HEADING_FOUR_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_HEADING_FOUR_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_FOUR_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_FOUR_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_SMALL_FONT_SIZE = "1.296rem";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_MEDIUM_FONT_SIZE = "1.424rem";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_MEDIUM_SPACER = "1.25rem";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_LARGE_FONT_SIZE = "1.44rem";
export const TYPOGRAPHY_HEADING_FOUR_VIEWPORT_LARGE_SPACER = "1.5rem";
export const TYPOGRAPHY_HEADING_FIVE_NAME = "h5";
export const TYPOGRAPHY_HEADING_FIVE_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_HEADING_FIVE_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_FIVE_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_FIVE_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_SMALL_FONT_SIZE = "1.215rem";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_MEDIUM_FONT_SIZE = "1.266rem";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_MEDIUM_SPACER = "1.25rem";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_LARGE_FONT_SIZE = "1.266rem";
export const TYPOGRAPHY_HEADING_FIVE_VIEWPORT_LARGE_SPACER = "1.5rem";
export const TYPOGRAPHY_HEADING_SIX_NAME = "h6";
export const TYPOGRAPHY_HEADING_SIX_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_HEADING_SIX_FONT_WEIGHT = "400";
export const TYPOGRAPHY_HEADING_SIX_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_HEADING_SIX_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_SMALL_FONT_SIZE = "1.215rem";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_SMALL_SPACER = "1rem";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_MEDIUM_FONT_SIZE = "1.266rem";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_MEDIUM_SPACER = "1.25rem";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_LARGE_FONT_SIZE = "1.266rem";
export const TYPOGRAPHY_HEADING_SIX_VIEWPORT_LARGE_SPACER = "1.5rem";
export const TYPOGRAPHY_MARKETING_NAME = "marketing";
export const TYPOGRAPHY_MARKETING_FONT_FAMILY = "'British Gas Subhead', sans-serif";
export const TYPOGRAPHY_MARKETING_FONT_WEIGHT = "400";
export const TYPOGRAPHY_MARKETING_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_MARKETING_LINE_HEIGHT = "1.2";
export const TYPOGRAPHY_MARKETING_VIEWPORT_SMALL_FONT_SIZE = "2.056rem";
export const TYPOGRAPHY_MARKETING_VIEWPORT_SMALL_SPACER = "0.5rem";
export const TYPOGRAPHY_MARKETING_VIEWPORT_MEDIUM_FONT_SIZE = "2.884rem";
export const TYPOGRAPHY_MARKETING_VIEWPORT_MEDIUM_SPACER = "0.5rem";
export const TYPOGRAPHY_MARKETING_VIEWPORT_LARGE_FONT_SIZE = "4.3rem";
export const TYPOGRAPHY_MARKETING_VIEWPORT_LARGE_SPACER = "0.5rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_NAME = "p-large";
export const TYPOGRAPHY_PARAGRAPH_LARGE_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_PARAGRAPH_LARGE_FONT_WEIGHT = "400";
export const TYPOGRAPHY_PARAGRAPH_LARGE_LETTER_SPACING = "-0.013em";
export const TYPOGRAPHY_PARAGRAPH_LARGE_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_SMALL_FONT_SIZE = "1.476rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_SMALL_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_MEDIUM_FONT_SIZE = "1.602rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_MEDIUM_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_LARGE_FONT_SIZE = "1.602rem";
export const TYPOGRAPHY_PARAGRAPH_LARGE_VIEWPORT_LARGE_SPACER = "1rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_NAME = "p-feature";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_FONT_WEIGHT = "400";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_LETTER_SPACING = "-0.013em";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_SMALL_FONT_SIZE = "1.215rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_SMALL_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_MEDIUM_FONT_SIZE = "1.424rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_MEDIUM_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_LARGE_FONT_SIZE = "1.424rem";
export const TYPOGRAPHY_PARAGRAPH_FEATURE_VIEWPORT_LARGE_SPACER = "1rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_NAME = "p-normal";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_FONT_WEIGHT = "400";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_LETTER_SPACING = "-0.013em";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_SMALL_FONT_SIZE = "1.067rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_SMALL_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_MEDIUM_FONT_SIZE = "1.125rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_MEDIUM_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_LARGE_FONT_SIZE = "1.125rem";
export const TYPOGRAPHY_PARAGRAPH_NORMAL_VIEWPORT_LARGE_SPACER = "1rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_NAME = "p-small";
export const TYPOGRAPHY_PARAGRAPH_SMALL_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_PARAGRAPH_SMALL_FONT_WEIGHT = "400";
export const TYPOGRAPHY_PARAGRAPH_SMALL_LETTER_SPACING = "-0.013em";
export const TYPOGRAPHY_PARAGRAPH_SMALL_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_SMALL_FONT_SIZE = "1rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_SMALL_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_MEDIUM_FONT_SIZE = "1.067rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_MEDIUM_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_LARGE_FONT_SIZE = "1.067rem";
export const TYPOGRAPHY_PARAGRAPH_SMALL_VIEWPORT_LARGE_SPACER = "1rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_NAME = "p-caption";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_FONT_FAMILY = "'British Gas Body', sans-serif";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_FONT_WEIGHT = "400";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_LETTER_SPACING = "-0.013em";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_SMALL_FONT_SIZE = "0.889rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_SMALL_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_MEDIUM_FONT_SIZE = "0.889rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_MEDIUM_SPACER = "0.75rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_LARGE_FONT_SIZE = "0.889rem";
export const TYPOGRAPHY_PARAGRAPH_CAPTION_VIEWPORT_LARGE_SPACER = "1rem";
export const TYPOGRAPHY_ACTION_NAME = "action";
export const TYPOGRAPHY_ACTION_FONT_FAMILY = "'British Gas Medium', sans-serif";
export const TYPOGRAPHY_ACTION_FONT_WEIGHT = "400";
export const TYPOGRAPHY_ACTION_LETTER_SPACING = "-0.0145em";
export const TYPOGRAPHY_ACTION_LINE_HEIGHT = "1.5";
export const TYPOGRAPHY_ACTION_VIEWPORT_SMALL_FONT_SIZE = "1rem";
export const TYPOGRAPHY_ACTION_VIEWPORT_SMALL_SPACER = "0.5rem";
export const TYPOGRAPHY_ACTION_VIEWPORT_MEDIUM_FONT_SIZE = "1.067rem";
export const TYPOGRAPHY_ACTION_VIEWPORT_MEDIUM_SPACER = "0.5rem";
export const TYPOGRAPHY_ACTION_VIEWPORT_LARGE_FONT_SIZE = "1.067rem";
export const TYPOGRAPHY_ACTION_VIEWPORT_LARGE_SPACER = "0.5rem";
export const VIEWPORT_SQUASH_COURT = "320px";
export const VIEWPORT_TENNIS_COURT = "480px";
export const VIEWPORT_BASKETBALL_COURT = "720px";
export const VIEWPORT_HOCKEY_PITCH = "1080px";
export const VIEWPORT_FOOTBALL_PITCH = "1270px";
export const VIEWPORT_RUGBY_PITCH = "1620px";
export const VIEWPORT_POLO_FIELD = "2430px";
export const ALERT_BACKGROUND_COLOR_ERROR = "#fdf2f3";
export const ALERT_BACKGROUND_COLOR_WARNING = "#fcf4f2";
export const ALERT_BACKGROUND_COLOR_SUCCESS = "#f2f7f4";
export const ALERT_BACKGROUND_COLOR_INFORMATION = "#f2f6fd";
export const DOWNLOAD_ICON_SIZE_VIEWPORT_DEFAULT = "1rem";
export const DOWNLOAD_ICON_SIZE_VIEWPORT_BASKETBALL_COURT = "1.125rem";
export const DOWNLOAD_ICON_SIZE_VIEWPORT_RUGBY_PITCH = "1.25rem";
export const DOWNLOAD_LIST_PADDING_BLOCK_END = "1.2em";
export const DOWNLOAD_LIST_INFO_FONT_SIZE = "0.8em";
export const DOWNLOAD_LIST_INFO_POSITION_LEFT = "1.5em";
export const LANDMARK_GRADIENT_ANGLE_DEFAULT = "350deg";
export const LANDMARK_GRADIENT_ANGLE_HOCKEY_PITCH = "260deg";
export const LANDMARK_GRADIENT_WIDTH = "50%";
export const LANDMARK_GRADIENT_COLOR_WHITE = "rgb(255 255 255 / 30%)";
export const LANDMARK_GRADIENT_COLOR_BLUE = "rgb(0 78 204 / 50%)";
export const LANDMARK_GRADIENT_COLOR_CYAN = "#47B6FF";
export const BUTTON_FUNCTIONAL_ICONS = ["chevron","chevron-left","chevron-right","chevron-up","chevron-down","plus","minus","cross","search"];
export const BUTTON_DEFAULT_ICON = "plus";
export const PANEL_DECORATIONS = ["cyan","cyan-light","lime","lime-light","navy","navy-light","blue","forest","forest-light","slate","orange","orange-light","red","yellow","yellow-light","white","grey-light"];
export const PILL_THEMES = ["cyan","lime","navy","forest","slate","orange","red","yellow"];
export const TESTIMONIAL_BORDER_WIDTH = "0.125rem";
export const TESTIMONIAL_DECORATION_BACKGROUND_COLOR = "#0093F5";
export const TESTIMONIAL_DECORATION_COLOR = "#FFFFFF";
export const TESTIMONIAL_TRIANGLE_SIZE = "1.5rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_SMALL_VIEWPORT_DEFAULT = "2rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_SMALL_VIEWPORT_BASKETBALL_COURT = "2.25rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_SMALL_VIEWPORT_RUGBY_PITCH = "3rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_LARGE_VIEWPORT_DEFAULT = "2.25rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_LARGE_VIEWPORT_BASKETBALL_COURT = "3rem";
export const TIMELINE_EVENT_CIRCLE_SIZE_LARGE_VIEWPORT_RUGBY_PITCH = "3.5rem";
